import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "legal-page" }

import "@/assets/styles/legal.css";

export default /*@__PURE__*/_defineComponent({
  __name: 'ImpressumView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<div class=\"legal-container\"><span class=\"legal-badge\"> Impressum </span><h1> Angaben gemäß § 5 TMG </h1><div class=\"legal-card\"><h2>Unternehmen</h2><p> Firmenname<br> Dachdecker<br> Max Mustermann </p></div><div class=\"legal-card\"><h2>Adresse</h2><p> Musterstraße 12<br> 65183 Wiesbaden<br> Deutschland </p></div><div class=\"legal-card\"><h2>Kontakt</h2><p> Telefon: +49 123 456789<br> E-Mail: info@dachdecker.de </p></div><div class=\"legal-card\"><h2>Verantwortlich für den Inhalt</h2><p> Max Mustermann<br> Musterstraße 12<br> 65183 Wiesbaden </p></div><div class=\"legal-card\"><h2>Haftungshinweis</h2><p> Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte externer Links. Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich. </p></div></div>", 1)
  ]))]))
}
}

})